import { render } from "./WeekendDecoratorComponent.vue?vue&type=template&id=47eadf74&scoped=true"
import script from "./WeekendDecoratorComponent.vue?vue&type=script&lang=js"
export * from "./WeekendDecoratorComponent.vue?vue&type=script&lang=js"

import "./WeekendDecoratorComponent.vue?vue&type=style&index=0&id=47eadf74&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47eadf74"]])

export default __exports__